import React from 'react';
import { Button, CircularProgress, Tooltip } from '@mui/material';
import AutoFixHighIcon from '@mui/icons-material/AutoFixHigh';

export default function AiReviewButton({ enabled, loading, reviewing, onClick, disabledReason }) {
  const title = enabled
    ? 'Grade worksheet with AI'
    : disabledReason || 'AI worksheet review is disabled';

  return (
    <Tooltip title={title}>
      <span>
        <Button
          size="small"
          variant="outlined"
          color="secondary"
          startIcon={reviewing ? <CircularProgress size={16} /> : <AutoFixHighIcon />}
          onClick={onClick}
          disabled={!enabled || reviewing || loading}
        >
          {reviewing ? 'Reviewing worksheet...' : 'Grade with AI'}
        </Button>
      </span>
    </Tooltip>
  );
}
